import formatNumber from "./formatNumber";

/** Change precision based on the value:
 *  - For fractions less than 1 in value, use 3 decimal places
 *  - Values lower than 100, use 1 decimal place
 *  - For other values, round to integer
 * @param { Number } number the number to display.
 */
export default function flexibleFormat(number) {
  if (Math.abs(number) < 1) {
    return formatNumber(number, 3);
  } else if (Math.abs(number) < 100) {
    return formatNumber(number, 1);
  } else {
    return formatNumber(number, 0);
  }
}
